import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=7c99d8c3&scoped=true&"
import script from "./UserSelector.vue?vue&type=script&lang=js&"
export * from "./UserSelector.vue?vue&type=script&lang=js&"
import style0 from "./UserSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserSelector.vue?vue&type=style&index=1&id=7c99d8c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99d8c3",
  null
  
)

component.options.__file = "UserSelector.vue"
export default component.exports